<template>
    <section class="our-story">
        <div class="story-image">
            <img 
             :src="leatherCraft"
             alt="Leather craft">
                 </div>
                 <div class="story-text">
                    <h2>Our Story</h2>
                    <p>Our Story began with a simple idea: to make quality leather products that combine timeless style, durability, and everyday practicality. We believe that the right accessory should not only look good but also be made to last. From carefully selected bags and shoes to classic belts, our collection is designed for people who appreciate simple, elegant, and functional pieces. Every product is chosen with attention to detail, craftsmanship, and style, with the goal of giving our customers leather pieces they can enjoy and rely on for years to come. What started as a love for well-crafted leather has grown into a store dedicated to making quality and style accessible to everyone.</p>
              
                 </div>
    </section>
</template>

<script>
import leatherCraft from '@/assets/leathercraft.jpg'

export default {
  name: 'AboutPage',

  data() {
    return {
      leatherCraft
    }
  }
}
</script>

<style scoped>
.our-story{
    display: flex;
    align-items: center;
    gap: 60px;
    padding: 80px 8%;
    background-color: #ffffff;
}

.story-image{
    width: 50%;
}

.story-image img{
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 8px;
}

.story-text{
    width: 50%;
}

.story-text h2{
    color: #292929;
    font-size: 17px;
    margin-bottom: 20px;
}

.story-text p{
    color: #4a4541;
    font-size: 17px;
    line-height: 1.8;
    margin-bottom: 15px;
}

/* OUR STORY RESPONSIVENESS */

@media (max-width: 768px) {

  .our-story {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 50px 30px;
  }

  .story-image,
  .story-text {
    width: 100%;
    max-width: 600px;
  }

  .story-image img {
    display: block;
    width: 100%;
    height: auto;
  }

  .story-text {
    text-align: center;
  }

  .story-text h2 {
    font-size: 30px;
  }

  .story-text p {
    font-size: 16px;
    line-height: 1.6;
  }

}


@media (max-width: 480px) {

  .our-story {
    padding: 35px 20px;
    gap: 20px;
  }

  .story-text h2 {
    font-size: 26px;
  }

  .story-text p {
    font-size: 14px;
  }

}
</style>